import StyledRangeSlider from '../../../components/StyledRangeSlider.jsx';

/**
 * @param {{
 *   visibleHeightM: number;
 *   maxVisibleHeightM: number;
 *   onVisibleHeightChange: (value: number) => void;
 *   hidden?: boolean;
 * }} props
 */
function VisibleHeightControl({
  visibleHeightM,
  maxVisibleHeightM,
  onVisibleHeightChange,
  hidden = false,
}) {
  if (hidden) return null;

  return (
    <div className="floor-plan-workspace-visible-height card">
      <label className="floor-plan-visible-height-control">
        <span className="floor-plan-visible-height-label">
          Visible height
          <span className="floor-plan-visible-height-value">{visibleHeightM.toFixed(2)} m</span>
        </span>
        <StyledRangeSlider
          min={0}
          max={maxVisibleHeightM}
          step={0.05}
          value={visibleHeightM}
          onInput={(e) => onVisibleHeightChange(Number(e.currentTarget.value))}
          aria-label="Visible height in meters"
        />
      </label>
    </div>
  );
}

export default VisibleHeightControl;
